import { useState } from 'react';
import { Paper, Text, Box } from '@mantine/core';
import BotLiveDashboard from './BotLiveDashboard';
import { BotSettingsContext, BotGameContext, BotActionsContext } from './BotContext';

/**
 * BotDemo component provides an interactive preview of the BotLiveDashboard.
 * It uses a mock context to show what the dashboard looks like during an active game.
 */
export default function BotDemo() {
    const [answerMode, setAnswerMode] = useState('own');
    const [history, setHistory] = useState([]);
    const [timeline, setTimeline] = useState([
        { title: "Quiz Started", message: "Good luck!", type: "success", time: "10:00:01" },
        { title: "Podium Reached!", message: "Bot-01 placed Rank #1!", type: "success", time: "10:02:45" }
    ]);

    const demoSettingsValue = {
        form: { pin: '8675309', amount: 50 },
    };

    const demoGameValue = {
        gameState: 'question',
        botCount: 42,
        timeLeft: 12000,
        totalTime: 20000,
        answerMode: answerMode,
        timeline: timeline,
        podium: [],
        questionNumber: 3,
    };

    const demoActionsValue = {
        setAnswerMode: setAnswerMode,
        sendAnswer: (idx) => {
            setHistory(prev => [idx, ...prev].slice(0, 5));
            const symbols = ['Triangle', 'Diamond', 'Circle', 'Square'];
            const newEvent = {
                title: `Answer Sent (Q3)`,
                message: `Manual command: ${symbols[idx]}`,
                type: 'answer',
                data: idx,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })
            };
            setTimeline(prev => [newEvent, ...prev]);
        },
        disconnectBots: () => alert("This is just a demo! Launch the real tool above."),
        setForm: () => {},
        setSetupStep: () => {},
        setLoading: () => {},
        setErrors: () => {},
        connectSocket: () => {},
    };

    return (
        <Box pos="relative">
            <BotActionsContext.Provider value={demoActionsValue}>
                <BotSettingsContext.Provider value={demoSettingsValue}>
                    <BotGameContext.Provider value={demoGameValue}>
                        <Paper
                            shadow="xl"
                            radius="lg"
                            withBorder
                            style={{
                                overflow: 'hidden',
                            }}
                        >
                            {/* Reuse your actual component! */}
                            <BotLiveDashboard demoHistory={history} />

                            {/* A "Demo Mode" Badge Overlay */}
                            <Paper
                                py={4} px="sm"
                                bg="blue"
                                radius="xl"
                                style={{ position: 'absolute', top: 10, right: 10, zIndex: 10 }}
                            >
                                <Text c="white" size="xs" fw={700}>INTERACTIVE DEMO</Text>
                            </Paper>
                        </Paper>
                    </BotGameContext.Provider>
                </BotSettingsContext.Provider>
            </BotActionsContext.Provider>
        </Box>
    );
}